import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

// Cloudflare Turnstile (anti-robots invisible) para el login y el registro.
// Supabase Auth valida el token del lado del servidor (Attack Protection →
// CAPTCHA). Sin site key configurada no se muestra nada.
const SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let cargaScript = null;

function cargarScript() {
  if (window.turnstile) return Promise.resolve();
  if (!cargaScript) {
    cargaScript = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = SCRIPT; s.async = true; s.defer = true;
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return cargaScript;
}

const Turnstile = forwardRef(function Turnstile({ siteKey, onToken }, ref) {
  const caja = useRef(null);
  const widget = useRef(null);

  useImperativeHandle(ref, () => ({
    // Cada token sirve una sola vez: tras un intento fallido hay que pedir otro.
    reiniciar: () => { onToken(null); if (window.turnstile && widget.current != null) window.turnstile.reset(widget.current); },
  }));

  useEffect(() => {
    if (!siteKey) return undefined;
    let activo = true;
    cargarScript().then(() => {
      if (!activo || !caja.current || widget.current != null) return;
      widget.current = window.turnstile.render(caja.current, {
        sitekey: siteKey,
        language: 'es',
        callback: (token) => onToken(token),
        'expired-callback': () => onToken(null),
        'error-callback': () => onToken(null),
      });
    }).catch(() => onToken(null));
    return () => {
      activo = false;
      if (window.turnstile && widget.current != null) window.turnstile.remove(widget.current);
      widget.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteKey]);

  if (!siteKey) return null;
  return <div ref={caja} style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px', minHeight: '65px' }} />;
});

export default Turnstile;
